import React, { useState, useEffect, useCallback, useRef } from "react";
import useStyles from "./style";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  useMediaQuery,
  Grid,
  TextField,
  MenuItem,
  Box,
  Avatar,
  Typography
} from "@mui/material";
import { useTheme } from '@mui/material/styles';
import _ from "lodash";
import { useNavigate } from 'react-router-dom';
//Libs
import { showLoader, hideLoader } from "Redux/Loader/actions";
import { showSnackbar } from "Redux/SnackBar/actions";
import { useDispatch, useSelector } from "react-redux";

//Services
import DispatcherApi from "Services/Dispatcher";

const Assigndriver = (props) => {
  const {
    openDialog,
    assigndriverModal,
    formvalues,
    formValues,
    handleClose,
    setAssigndriverModal,
    handledisagree,
    userType,
    subcmpnyName,
    onSuccessCallback,
  } = props;
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const classes = useStyles();
  const dispatch = useDispatch();
  const demoaccount_id = useSelector((state) => state?.AuthReducer?.demoaccount_id || "");
  const [activedrivers, setActivedrivers] = useState([]);
  const [selecteddriver, setSelecteddriver] = useState(null);
  const navigate = useNavigate();

  const isOpen = Boolean(openDialog ?? assigndriverModal);
  const activeFormValues = formvalues || formValues || {};

  const handleDialogClose = () => {
    if (handleClose) {
      handleClose();
    }
    if (setAssigndriverModal) {
      setAssigndriverModal(false);
    }
  };

  const handleDialogDisagree = () => {
    if (handledisagree) {
      handledisagree();
    } else {
      handleDialogClose();
    }
  };

  const fetchnearbydrivers = useCallback(() => {
    if (!activeFormValues?.s_latitude || !activeFormValues?.s_longitude || !activeFormValues?.service_type) {
      return;
    }
    dispatch(showLoader("Loading please wait..."));
    const data = {
      s_latitude: activeFormValues.s_latitude,
      s_longitude: activeFormValues.s_longitude,
      service_type: activeFormValues.service_type,
    };
    if (demoaccount_id) {
      data.demoaccount_id = demoaccount_id;
    }
    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        setActivedrivers(res.data?.data || []);
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "No drivers available around",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };
    DispatcherApi.fetchnearbydrivers(data).then(onSuccess, onFailure);
  }, [activeFormValues?.s_latitude, activeFormValues?.s_longitude, activeFormValues?.service_type, demoaccount_id, dispatch]);

  useEffect(() => {
    if (isOpen) {
      setSelecteddriver(null);
      fetchnearbydrivers();
    }
  }, [isOpen, fetchnearbydrivers]);

  const filteredDrivers = (activedrivers || []).filter(
    (driver) =>
      userType !== "SUB COMPANY" ||
      (userType === "SUB COMPANY" && subcmpnyName && driver?.sub_companyName === subcmpnyName)
  );

  const handleselectedservicedrivers = (event) => {
    setSelecteddriver(event.target.value);
  };

  const Assignselecteddriver = () => {
    if (!selecteddriver) {
      dispatch(
        showSnackbar({
          message: "Please select a driver to assign",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
      return;
    }

    dispatch(showLoader("Loading please wait..."));
    const submitPayload = { ...activeFormValues, provider_id: selecteddriver };

    const onSuccess = (res) => {
      dispatch(hideLoader());
      if (res?.data?.status === true) {
        dispatch(
          showSnackbar({
            message: "Trip Assigned Successfully",
            autoHideDuration: 3000,
            anchorOrigin: {
              vertical: "top",
              horizontal: "right",
            },
            variant: "success",
          })
        );

        if (onSuccessCallback) {
          onSuccessCallback(res);
        } else if (activeFormValues?.isPackage) {
          navigate('/package-delivery-triplist');
        } else {
          navigate('/triplist');
        }
        handleDialogClose();
      }
    };
    const onFailure = (err) => {
      dispatch(hideLoader());
      dispatch(
        showSnackbar({
          message: err?.response?.data?.message || "Error in assign driver",
          autoHideDuration: 3000,
          anchorOrigin: {
            vertical: "top",
            horizontal: "right",
          },
          variant: "error",
        })
      );
    };

    DispatcherApi.assignridebydispatcher(submitPayload).then(onSuccess, onFailure);
  };

  return (
    <>
      <React.Fragment>
        <Dialog
          fullScreen={fullScreen}
          open={isOpen}
          onClose={handleDialogClose}
          aria-labelledby="responsive-dialog-title"
        >
          <DialogTitle id="responsive-dialog-title">
            {"Select the nearby drivers to assign trip"}
          </DialogTitle>
          <DialogContent>

            <Grid container spacing={2} rowSpacing={3} columnSpacing={4} className={classes.dialogbox}>
              <Grid item xs={12} >
                <div>
                  <TextField
                    name="activedrivers"
                    id="activedrivers"
                    select
                    label="Available drivers"
                    onChange={handleselectedservicedrivers}
                    value={selecteddriver ? selecteddriver : ""}
                    fullWidth
                    variant="outlined"
                    size="small"
                  >
                    {filteredDrivers.length === 0 ? (
                      <MenuItem disabled value="">
                        No nearby drivers available
                      </MenuItem>
                    ) : (
                      filteredDrivers.map((drivers) => {
                        const firstName = drivers.userDetails?.firstName || "";
                        const lastName  = drivers.userDetails?.lastName  || "";
                        const mobile    = drivers.userDetails?.mobileNumber || drivers.mobileNumber || "";
                        const initials  = `${firstName.charAt(0)}${lastName.charAt(0)}`.toUpperCase();
                        return (
                          <MenuItem key={drivers._id} value={drivers._id} sx={{ p: 0 }}>
                            <Box
                              sx={{
                                display: "flex",
                                alignItems: "center",
                                gap: 1.5,
                                px: 1.5,
                                py: 1,
                                width: "100%",
                                borderRadius: 1,
                                "&:hover": { backgroundColor: "rgba(25,118,210,0.06)" },
                              }}
                            >
                              <Avatar
                                sx={{
                                  width: 36,
                                  height: 36,
                                  fontSize: 13,
                                  fontWeight: 700,
                                  bgcolor: "primary.main",
                                  flexShrink: 0,
                                }}
                              >
                                {initials || "D"}
                              </Avatar>
                              <Box sx={{ display: "flex", flexDirection: "column", minWidth: 0 }}>
                                <Typography
                                  variant="body2"
                                  sx={{ fontWeight: 600, lineHeight: 1.3, color: "text.primary" }}
                                >
                                  {`${firstName} ${lastName}`.trim() || "Unknown Driver"}
                                </Typography>
                                {mobile && (
                                  <Typography
                                    variant="caption"
                                    sx={{ color: "text.secondary", lineHeight: 1.3 }}
                                  >
                                    📞 {mobile}
                                  </Typography>
                                )}
                              </Box>
                            </Box>
                          </MenuItem>
                        );
                      })
                    )}
                  </TextField>
                </div>
              </Grid>
            </Grid>

          </DialogContent>
          <DialogActions>
            <Button autoFocus onClick={handleDialogDisagree}>
              Disagree
            </Button>
            <Button onClick={Assignselecteddriver} autoFocus>
              Agree
            </Button>
          </DialogActions>
        </Dialog>
      </React.Fragment>
    </>
  );
};

export default Assigndriver;
